import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import { StyledPopup } from 'components/Styled';
import { connect } from 'react-redux';
import { Col, Row } from 'antd';
import {
  ExportOutlined,
} from '@ant-design/icons';

import { StyledButton, PopupBody, MarkdownDiv } from 'components/Styled';
import PureModal from 'business/components/pureModal/index';

const RetireModal = () => {
  const { t } = useTranslation();
  const [display, setDisplay] = useState(true);

  const handleClose = () => {
    setDisplay(false);
  };

  const handleToNewVersion = () => {
    window.open('https://ship.spaceshipapp.com/', '_blank').focus();
  };

  return (
    <PureModal
      visible={display}
      closeable={false}
      maskClosable={false}
      maskStyle={{ zIndex: 1052 }}
      bodyStyle={{ width: 800, height: 'auto' }}>
      <div />
      <PopupBody className="popup-body" style={{ maxWidth: 800 }}>
        <div>
          <StyledPopup>
            <div className="title buttonTheme-color">
              {t('retireModal.title')}
            </div>
            <MarkdownDiv style={{ fontSize: '18px' }}>
              <ReactMarkdown source={t('retireModal.content')} />
            </MarkdownDiv>
          </StyledPopup>
          <div style={{ padding: '20px' }}>
            <Row gutter={16}>
              <Col span={12}>
                <StyledButton onClick={handleToNewVersion} shadow="true">
                  <ExportOutlined /> {t('retireModal.goToNewVersionButton')}
                </StyledButton>
              </Col>
              <Col span={12}>
                <StyledButton onClick={handleClose} type="primary" shadow="true">
                  {t('common.ok')}
                </StyledButton>
              </Col>
            </Row>
          </div>
        </div>
      </PopupBody>
    </PureModal>
  );
};

const mapStateToProps = state => {
  return {
    isLoggedIn: Boolean(state.auth.user)
  };
};

export default connect(mapStateToProps)(RetireModal);
